// src/pages/salary/components/SalaryComposition.jsx
import { DollarSign, TrendingUp, Calculator, Shield, PieChart, BarChart3 } from '.';
import Mo3tiProgressBar from './Mo3tiProgressBar';

const SalaryComposition = ({ payrollData, calculatedValues, styles, t, theme, isRTL, onMouseEnter, onMouseLeave }) => {
  const items = [
    {
      category: t.basicSalary,
      amount:   payrollData.basicSalary.toFixed(1),
      percentage: ((payrollData.basicSalary / payrollData.grossSalary) * 100).toFixed(1),
      icon: DollarSign,
    },
    {
      category: t.allowances,
      amount:   payrollData.totalAllowances,
      percentage: ((payrollData.totalAllowances / payrollData.grossSalary) * 100).toFixed(1),
      icon: TrendingUp,
    },
    {
      category: t.incomeTax,
      amount:   parseFloat(payrollData.monthlyTax).toFixed(1),
      percentage: ((payrollData.monthlyTax / payrollData.grossSalary) * 100).toFixed(1),
      icon: Calculator, isDeduction: true,
    },
    {
      category: t.socialInsurance,
      amount:   parseFloat(calculatedValues.socialInsurance).toFixed(1),
      percentage: ((calculatedValues.socialInsurance / payrollData.grossSalary) * 100).toFixed(1),
      icon: Shield, isDeduction: true,
    },
  ];

  return (
    <>
      <div style={styles.card1}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', direction: isRTL ? 'rtl' : 'ltr', flexDirection: isRTL ? 'row-reverse' : 'row' }}>
            <PieChart size={24} color="#2e7cba" />
            <h2 style={{ color: theme === 'dark' ? '#ffffff' : '#0f172a', fontSize: 'clamp(16px, 3vw, 20px)', fontWeight: '700', margin: 0 }}>{t.salaryComposition}</h2>
          </div>
        </div>
        <div style={styles.compositionGrid}>
          {items.map((item, i) => (
            <div key={i} style={styles.compositionCard} className="hover-card" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
              <div style={styles.compositionIcon}><item.icon size={24} /></div>
              <h3 style={styles.compositionTitle}>{item.category}</h3>
              <p style={styles.compositionAmount}>{item.isDeduction ? '-' : ''}{Math.abs(item.amount).toLocaleString()} {t.egp}</p>
              <Mo3tiProgressBar percentage={parseFloat(item.percentage)} color="#2e7cba" theme={theme} />
              <p style={styles.compositionPercentage}>{item.percentage}% {t.ofGrossSalary}</p>
            </div>
          ))}
        </div>
      </div>

      <div style={styles.card1}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', direction: isRTL ? 'rtl' : 'ltr', flexDirection: isRTL ? 'row-reverse' : 'row' }}>
            <BarChart3 size={24} color="#2e7cba" />
            <h2 style={{ color: theme === 'dark' ? '#ffffff' : '#0f172a', fontSize: 'clamp(16px, 3vw, 20px)', fontWeight: '700', margin: 0 }}>{t.salarySummary}</h2>
          </div>
        </div>
        <div style={styles.summaryGrid}>
          {[
            { value: payrollData.grossSalary.toFixed(1),   label: t.monthlyGrossSalary, color: null },
            { value: `-${payrollData.totalDeductions.toFixed(1)}`, label: t.totalDeductions, color: '#2e7cba' },
            { value: payrollData.netSalary.toFixed(1),     label: t.netTakeHomePay,     color: '#2e7cba' },
          ].map((item, i) => (
            <div key={i} style={styles.summaryItem}>
              <div style={{ ...styles.summaryValue, ...(item.color ? { color: item.color } : {}) }}>{item.value}</div>
              <div style={styles.summaryLabel}>{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default SalaryComposition;